<div>
  <h2 mat-dialog-title>Opret kalender annotation</h2>
  <mat-dialog-content>
    <mat-form-field>
      <mat-label>Type</mat-label>
      <mat-select [(ngModel)]="type">
        <mat-option [value]="CalendarItemType.DenyDate">Lås dato for udsendelser</mat-option>
        <mat-option [value]="CalendarItemType.Comment">Kommentar</mat-option>
        <mat-option [value]="CalendarItemType.HqNonWorkingDayExplicit">Ikke-arbejdsdag på Hovedkontoret</mat-option>
      </mat-select>
    </mat-form-field>

    @if (type == CalendarItemType.DenyDate) {
    <mat-form-field>
      <mat-label>Årsag</mat-label>
      <textarea matInput [(ngModel)]="description" required></textarea>
      <mat-hint>Årsag til hvorfor der ikke må udsendes denne dato</mat-hint>
    </mat-form-field>
    }

    @if (type == CalendarItemType.Comment) {
    <mat-form-field>
      <mat-label>Kommentar</mat-label>
      <textarea matInput [(ngModel)]="description" required></textarea>
      <mat-hint>Kommentar til datoen</mat-hint>
    </mat-form-field>
    }

    @if (type == CalendarItemType.HqNonWorkingDayExplicit) {
    <mat-form-field>
      <mat-label>Beskrivelse</mat-label>
      <textarea matInput [(ngModel)]="description"></textarea>
      <mat-hint>Fridag, ferie, etc.</mat-hint>
    </mat-form-field>
    }

  </mat-dialog-content>
  <mat-dialog-actions>
    <span style="flex: 1 0 auto;"></span>
    <button mat-button color="primary" [mat-dialog-close]="{type: type, date: data.date, description}">Gem</button>
  </mat-dialog-actions>
</div>
